import React from 'react'
import { useNavigate, Link } from 'react-router-dom';
//import styles
import style from "./a.module.scss";
//import components
import Navbar from '../../components/Navbar/Navbar'
import GradientText from '../../components/GradientText/GradientText';
import SearchFields from '../../components/SearchFields/SearchFields';
import PrimaryButton from '../../components/PrimaryButton/PrimaryButton';
import Footer from '../../components/Footer/Footer'
import Card from './components/Card';
//import assets
import studyGroupHeroBackground from "../../assets/Backgrounds/studygroup-grid-background.svg";

const testCardData = [
    {
        groupName:'Data Structure and Algorithms',
        groupBy:'Aryan Jangid',
        about:'Our secondary goal is to build a strong mentoring relationship between our seasoned seniors and juniors',
        numberOfStudents:'55'
    },
    {
        groupName:'Application Developer',
        groupBy:'Sarthak Pawar',
        about:'Our secondary goal is to build a strong mentoring relationship between our seasoned seniors and juniors',
        numberOfStudents:'44'
    },
    {
        groupName:'UI Developer',
        groupBy:'Harsh Bhoje',
        about:'Our secondary goal is to build a strong mentoring relationship between our seasoned seniors and juniors',
        numberOfStudents:'33'
    },
    {
        groupName:'Web Developer',
        groupBy:'Om Gawande',
        about:'Our secondary goal is to build a strong mentoring relationship between our seasoned seniors and juniors',
        numberOfStudents:'45'
    },
]

const StudyGroups = () => {
    const navigate = useNavigate();
    const HeroSection = () =>{
        return(
            <div className={style.heroSection} style={{ backgroundImage: `url(${studyGroupHeroBackground})` }}>
                <h1>Find a correct <br/> place for <GradientText title="Yourself" color1='#407BFF' color2='#F32053'/></h1>
                <div className={style.searchPanel}>
                    <SearchFields />
                    <PrimaryButton title="Search" />
                </div>
            </div>
        )
    }
    
    const SearchResults = () => {
        return(
            <div className={style.searchResults} onClick={() => navigate('/groupinfo')}>
                {testCardData.map((data)=>{
                    return (
                        <Card data={data} />
                    )
                })}
            </div>
        )
    }

    return (
        <div>
            <Navbar />
            <div className="AppNavbarGap"></div>
            <HeroSection />
            <SearchResults />
            <Footer />
        </div>
  )
}

export default StudyGroups
